export const seamApiLtsVersion = '1.0.0';
//# sourceMappingURL=lts-version.js.map